import React from 'react';
import { SelectRole } from './components/SelectRole';
import './Signup.scss';

const SignupForm = () => {
  return <SelectRole />;
};

export default SignupForm;
